window.SAB_BOOKS = [
{
"h": "you-are-an-amazing-girl",
"t": "You Are an Amazing Girl",
"who": [
"girl"
],
"love": [
"stories"
],
"min": 6,
"max": 11,
"ages": "Ages 6-11",
"line": "Ten short stories that remind her how brave, capable and one of a kind she is, through girls who feel unsure, keep trying and find their courage.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "you-shine-amazing-girl",
"t": "You Shine, Amazing Girl",
"who": [
"girl"
],
"love": [
"stories"
],
"min": 6,
"max": 11,
"ages": "Ages 6-11",
"line": "Ten short stories that show her the kindest, bravest version of herself, and that believing in herself makes her light shine brighter.",
"by": "Kelly Brightwood",
"cat": "Children's Fiction"
},
{
"h": "never-stop-dreaming-girls",
"t": "Never Stop Dreaming, Girls",
"who": [
"girl"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories of girls who keep their dreams alive, in worlds she knows and enchanted ones, and show her that no dream is too big.",
"by": "Ellen Mills",
"cat": "Children's Fiction"
},
{
"h": "dream-big-and-be-yourself-girls",
"t": "Dream Big and Be Yourself, Girls",
"who": [
"girl"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories that tell her what she needs to hear when a dream feels too big: you are more capable than you realize.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "you-are-a-loved-girl",
"t": "You Are a Loved Girl",
"who": [
"girl"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories that remind her she is never alone: girls who doubt themselves and, with family and friends beside them, find their confidence.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "you-are-an-amazing-boy",
"t": "You Are an Amazing Boy",
"who": [
"boy"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten short stories of boys who get scared, keep trying and find out how brave they are, so he can believe in himself too.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "you-shine-amazing-boy",
"t": "You Shine, Amazing Boy",
"who": [
"boy"
],
"love": [
"stories"
],
"min": 6,
"max": 11,
"ages": "Ages 6-11",
"line": "Ten short stories that show him what true strength looks like: being brave, kind and honest, and growing from every challenge.",
"by": "Kelly Brightwood",
"cat": "Children's Fiction"
},
{
"h": "never-stop-dreaming-boys",
"t": "Never Stop Dreaming, Boys",
"who": [
"boy"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories of boys who keep their dreams alive, in worlds he knows and enchanted ones, and show him that no dream is too big.",
"by": "Ellen Mills",
"cat": "Children's Fiction"
},
{
"h": "dream-big-and-be-yourself-boys",
"t": "Dream Big and Be Yourself, Boys",
"who": [
"boy"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories that tell him what he needs to hear when a dream feels too big: you are more capable than you realize.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "you-are-a-loved-boy",
"t": "You Are a Loved Boy",
"who": [
"boy"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten stories that remind him he is never alone: boys who doubt themselves and, with family and friends beside them, find their courage.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "inspiring-stories-for-amazing-kids",
"t": "Inspiring Stories for Amazing Kids",
"who": [
"girl",
"boy"
],
"love": [
"stories"
],
"min": null,
"max": null,
"ages": null,
"line": "Ten magical adventures in fairy-tale worlds, with heroes who feel what kids feel and show them how to believe in their dreams.",
"by": "Nadia Ross",
"cat": "Children's Fiction"
},
{
"h": "emo-and-the-mystery-of-the-cloak",
"t": "Emo and the Mystery of the Cloak",
"who": [
"girl",
"boy"
],
"love": [
"stories"
],
"min": 6,
"max": 11,
"ages": "Ages 6-11",
"line": "A mystery kids can’t put down: a magical cloak, two new friends and clues to follow, with big feelings named along the way.",
"by": "Kelly Brightwood",
"cat": "Children's Fiction"
},
{
"h": "how-to-draw-almost-everything-kawaii",
"t": "How to Draw “Almost” Everything Kawaii",
"who": [
"girl",
"boy",
"teen"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300 kawaii drawings with big eyes and sweet smiles, from bubble tea to blushing bunnies, each in easy steps and with a fun fact.",
"by": null,
"cat": "Drawing"
},
{
"h": "how-to-draw-400-cute-stuff-for-kids-pink",
"t": "How to Draw 400 Cute Stuff for Kids, Pink Edition",
"who": [
"girl"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "400 of the cutest things to draw, from animals and mermaids to unicorns, food and fashion, one easy step at a time.",
"by": "Saemi Oliveira",
"cat": "Drawing"
},
{
"h": "how-to-draw-400-cute-stuff-for-kids-teal",
"t": "How to Draw 400 Cute Stuff for Kids, Teal Edition",
"who": [
"boy"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "400 cool things to draw, from animals and dinosaurs to monsters, sports, superheroes and vehicles, one easy step at a time.",
"by": "Saemi Oliveira",
"cat": "Drawing"
},
{
"h": "how-to-draw-almost-everything-for-kids-300-pink",
"t": "How to Draw “Almost” Everything for Kids, Pink Edition",
"who": [
"girl"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300 cute drawings, from animals and treats to fashion and fantasy creatures, each with a fun fact and super simple steps.",
"by": null,
"cat": "Drawing"
},
{
"h": "how-to-draw-almost-everything-for-kids-300-blue",
"t": "How to Draw “Almost” Everything for Kids, Blue Edition",
"who": [
"boy"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300 cool drawings of animals, insects, dinosaurs, space and fast food, each one built step by step from a few simple lines.",
"by": null,
"cat": "Drawing"
},
{
"h": "how-to-draw-almost-everything-for-kids-300-teal",
"t": "How to Draw “Almost” Everything for Kids, Teal Edition",
"who": [
"girl",
"boy"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300 cute drawings kids can actually finish, one simple step at a time, with a fun fact about every animal, treat, car and fantasy scene.",
"by": null,
"cat": "Drawing"
},
{
"h": "how-to-draw-everything-for-kids-400-purple",
"t": "How to Draw Everything for Kids (400), Purple Edition",
"who": [
"girl"
],
"love": [
"draw"
],
"min": 4,
"max": 12,
"ages": "Ages 4-12",
"line": "400 drawings of cute animals, flowers, unicorns, mermaids and fashion, each broken into simple shapes any beginner can follow.",
"by": "Renata Souza",
"cat": "Drawing"
},
{
"h": "how-to-draw-everything-for-kids-400-blue",
"t": "How to Draw Everything for Kids (400), Blue Edition",
"who": [
"boy"
],
"love": [
"draw"
],
"min": 4,
"max": 12,
"ages": "Ages 4-12",
"line": "400 drawings of cars, robots, dinosaurs, superheroes and rockets, each broken into simple shapes any beginner can follow.",
"by": "Renata Souza",
"cat": "Drawing"
},
{
"h": "how-to-draw-everything-for-kids-800",
"t": "How to Draw Everything for Kids (800)",
"who": [
"girl",
"boy"
],
"love": [
"draw"
],
"min": 4,
"max": 12,
"ages": "Ages 4-12",
"line": "800 drawings in one book, from cars and dinosaurs to unicorns and mermaids: kids will never run out of things to draw.",
"by": "Renata Souza",
"cat": "Drawing"
},
{
"h": "how-to-draw-800-cute-stuff-for-kids",
"t": "How to Draw 800 Cute Stuff for Kids",
"who": [
"girl",
"boy"
],
"love": [
"draw"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "Two favorites in one giant book: 800 cute and cool things to draw, from unicorns and fashion to dinosaurs and superheroes.",
"by": "Saemi Oliveira",
"cat": "Drawing"
},
{
"h": "the-ultimate-guide-on-how-to-draw-anime-and-manga-for-beginners-ren-ebit",
"t": "The Ultimate Guide on How to Draw Anime & Manga for Beginners, by Ren Ebit",
"who": [
"teen",
"grownup"
],
"love": [
"draw"
],
"min": null,
"max": null,
"ages": null,
"line": "Step-by-step lessons that take complete beginners from eyes and expressions to full anime and manga characters of their own.",
"by": "Ren Ebit",
"cat": "Drawing"
},
{
"h": "the-ultimate-guide-on-how-to-draw-realistic-things-in-3d",
"t": "The Ultimate Guide on How to Draw Realistic Things in 3D",
"who": [
"teen",
"grownup"
],
"love": [
"draw"
],
"min": null,
"max": null,
"ages": null,
"line": "Pencil lessons that turn flat sketches into drawings with depth: light, shadow and texture, explained step by step.",
"by": "Luara Rios",
"cat": "Drawing"
},
{
"h": "cozy-winter",
"t": "Cozy Winter",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "50 winter scenes to color: animals sipping hot cocoa, friends building snowmen and cozy cottages glowing under the stars.",
"by": "Inna",
"cat": "Coloring"
},
{
"h": "spooky-christmas",
"t": "Spooky Christmas",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Skeletons in Santa hats, haunted gingerbread houses and ghosts wrapping presents: 50 creepy-cute holiday scenes to color.",
"by": "Saemi Oliveira",
"cat": "Coloring"
},
{
"h": "cozy-cat-life",
"t": "Cozy Cat Life",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Cats napping in blankets, chasing yarn and lounging by sunny windows: cozy scenes to color on a slow evening.",
"by": null,
"cat": "Coloring"
},
{
"h": "cozy-dog-days",
"t": "Cozy Dog Days",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Dogs on sunny walks, napping in cozy corners and playing in gardens: happy dog days to color, for kids and adults alike.",
"by": "Saemi Oliveira",
"cat": "Coloring"
},
{
"h": "self-love-vibes",
"t": "Self-Love Vibes",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Skincare rituals, comfy socks, bubble baths and bookish afternoons: little cozy moments to color, just for you.",
"by": "Saemi Oliveira",
"cat": "Coloring"
},
{
"h": "girl-things",
"t": "Girl Things",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Cute, cozy scenes paired with self-love affirmations: a feel-good coloring book to be kind to yourself, one page at a time.",
"by": "Inna",
"cat": "Coloring"
},
{
"h": "fuzzy-in-love",
"t": "Fuzzy in Love",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "50 adorable animal pairs and heartwarming love scenes, from cozy couples to sweet patterns, with bold lines that are easy to color.",
"by": null,
"cat": "Coloring"
},
{
"h": "garden-scenes",
"t": "Garden Scenes",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Whimsical tea corners, cozy nooks under flowering trees and charming critters: a garden getaway to color, one page at a time.",
"by": "Saemi Oliveira",
"cat": "Coloring"
},
{
"h": "cozy-pet-days",
"t": "Cozy Pet Days",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Cats and dogs in one book: our Cozy Cat Days and Cozy Dog Days together, with cozy scenes for every pet lover.",
"by": "Saemi Oliveira",
"cat": "Coloring"
},
{
"h": "happy-friends",
"t": "Happy Friends",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Ten lovable animal characters, from Hugo the sloth to Momo the red panda, in cozy scenes of friendship to color.",
"by": "Renata Souza",
"cat": "Coloring"
},
{
"h": "cozy-autumn",
"t": "Cozy Autumn",
"who": [
"teen",
"grownup"
],
"love": [
"color"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Animals jumping in leaf piles, steaming mugs of cocoa, pumpkins and cozy sweaters: the simple magic of fall, ready to color.",
"by": "Inna",
"cat": "Coloring"
},
{
"h": "the-ultimate-activity-book-for-super-smart-girls",
"t": "The Ultimate Activity Book for Super Smart Girls",
"who": [
"girl"
],
"love": [
"puzzles"
],
"min": 8,
"max": 12,
"ages": "Ages 8-12",
"line": "100+ puzzles, mazes, word searches, sudoku and logic games for clever girls 8 to 12: start anywhere, solve at your own pace, check the answers at the end.",
"by": "Renata Souza",
"cat": "Activity"
},
{
"h": "the-ultimate-activity-book-for-super-smart-boys",
"t": "The Ultimate Activity Book for Super Smart Boys",
"who": [
"boy"
],
"love": [
"puzzles"
],
"min": 8,
"max": 12,
"ages": "Ages 8-12",
"line": "100+ puzzles, mazes, word searches, sudoku and logic games for clever boys 8 to 12: start anywhere, solve at your own pace, check the answers at the end.",
"by": "Renata Souza",
"cat": "Activity"
},
{
"h": "100-amazing-facts-for-kids",
"t": "100 Amazing Facts for Kids",
"who": [
"girl",
"boy"
],
"love": [
"puzzles"
],
"min": 6,
"max": 12,
"ages": "Ages 6-12",
"line": "100 amazing facts about animals, nature, Earth and science, each with a short, clear explanation, for curious kids ages 6 to 12.",
"by": "Brice Brant",
"cat": "Facts for Curious Kids & Minds"
},
{
"h": "amazing-facts-to-blow-your-mind",
"t": "Amazing Facts to Blow Your Mind",
"who": [
"girl",
"boy",
"teen"
],
"love": [
"puzzles"
],
"min": 10,
"max": null,
"ages": "Ages 10+",
"line": "Over 1,000 bizarre and brilliant facts, chapter by chapter: history, science, space and pop culture, for curious readers ages 10 and up.",
"by": "Brice Brant",
"cat": "Facts for Curious Kids & Minds"
},
{
"h": "historys-epic-mysteries",
"t": "History’s Epic Mysteries",
"who": [
"girl",
"boy"
],
"love": [
"puzzles"
],
"min": 8,
"max": 12,
"ages": "Ages 8-12",
"line": "40 real mysteries from every corner of the globe, from Stonehenge to the Wow! signal: kids weigh the clues and decide what really happened.",
"by": "Maria Dawn",
"cat": "Facts for Curious Kids & Minds"
},
{
"h": "super-skills-for-super-kids",
"t": "Super Skills for Super Kids",
"who": [
"girl",
"boy"
],
"love": [
"puzzles"
],
"min": 8,
"max": 12,
"ages": "Ages 8-12",
"line": "A fun guide to the everyday skills kids need: cooking basics and chores, making friends, saving money and staying safe online.",
"by": "Maria Dawn",
"cat": "Life Skills"
},
{
"h": "empowering-journal-for-girls",
"t": "Empowering Journal for Girls",
"who": [
"girl"
],
"love": [
"journal"
],
"min": 8,
"max": 12,
"ages": "Ages 8-12",
"line": "A journal that helps her see her strengths, speak kindly to herself and step from childhood into her teens with confidence.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "me-unfiltered",
"t": "Me, Unfiltered",
"who": [
"girl"
],
"love": [
"journal"
],
"min": 9,
"max": 12,
"ages": "Ages 9-12",
"line": "A tween journal that helps her figure out who she is, what she values and what she dreams of, as she steps into her teen years.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "my-creative-diary",
"t": "My Creative Diary",
"who": [
"girl"
],
"love": [
"journal",
"draw"
],
"min": 6,
"max": 12,
"ages": "Ages 6-12",
"line": "A diary full of drawing, writing, crafts and coloring that helps her discover her talents, express herself and believe in who she is.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "empowering-life-skills-for-teen-girls",
"t": "Empowering Life Skills for Teen Girls",
"who": [
"teen"
],
"love": [
"journal"
],
"min": 12,
"max": null,
"ages": "Ages 12+",
"line": "A guide for teen girls to discover who they are, build strong relationships, succeed at school and step into the world with confidence.",
"by": "Maria Dawn",
"cat": "Life Skills"
},
{
"h": "essential-life-skills-for-teens",
"t": "Essential Life Skills for Teens",
"who": [
"teen"
],
"love": [
"journal"
],
"min": 12,
"max": null,
"ages": "Ages 12+",
"line": "Straight talk for teens on time, friendships, money and confidence: practical skills for school now and for life after.",
"by": "Maria Dawn",
"cat": "Life Skills"
},
{
"h": "be-your-own-muse",
"t": "Be Your Own Muse",
"who": [
"grownup"
],
"love": [
"journal"
],
"min": null,
"max": null,
"ages": "Adults",
"line": "Daily exercises and reflections to stop chasing approval and reconnect with your own voice, creativity and strength.",
"by": "Nina Madsen",
"cat": "Self-Development"
},
{
"h": "rise-again",
"t": "Rise Again",
"who": [
"grownup"
],
"love": [
"journal"
],
"min": null,
"max": null,
"ages": "Adults",
"line": "A steadying companion for seasons of change and uncertainty: a guide for women about the very human power to begin again.",
"by": "Nina Madsen",
"cat": "Self-Development"
},
{
"h": "would-you-rather-christmas",
"t": "Would You Rather, Christmas Edition",
"who": [
"girl",
"boy",
"share"
],
"love": [
"laugh"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300+ holly-jolly questions and bonus group games that turn car rides, snow days and Christmas parties into laugh-out-loud fun.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "would-you-rather-fun-for-kids",
"t": "Would You Rather, Fun for Kids Edition",
"who": [
"girl",
"boy"
],
"love": [
"laugh"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300+ silly, mind-bending questions that get kids talking, laughing and thinking, on road trips, at sleepovers and on family game nights.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "would-you-rather-family",
"t": "Would You Rather, Family Edition",
"who": [
"share",
"grownup"
],
"love": [
"laugh"
],
"min": null,
"max": null,
"ages": null,
"line": "300+ funny, heartwarming questions for the whole family, with group play ideas that turn ordinary days into laugh-out-loud memories.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "would-you-rather-teen",
"t": "Would You Rather, Teen Edition",
"who": [
"teen"
],
"love": [
"laugh"
],
"min": null,
"max": null,
"ages": null,
"line": "Sharper, funnier dilemmas pitched at teen humor, for sleepovers, road trips and classroom ice-breakers.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "would-you-rather-history",
"t": "Would You Rather, History Edition",
"who": [
"girl",
"boy"
],
"love": [
"laugh"
],
"min": 6,
"max": null,
"ages": "Ages 6+",
"line": "300+ wild time-travel questions, from knights and vikings to Cleopatra, that make history something kids debate and laugh about.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "would-you-rather-fairy-tales",
"t": "Would You Rather, Fairy Tales Edition",
"who": [
"girl",
"boy"
],
"love": [
"laugh"
],
"min": null,
"max": null,
"ages": null,
"line": "300+ enchanted questions that turn classic fairy tales into laugh-out-loud adventures, with group challenges for bedtime, parties and class.",
"by": "Emerald Maroon",
"cat": "Activity"
},
{
"h": "mom-and-me-daughter",
"t": "Mom & Me, Daughter Edition",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": null,
"ages": "Ages 7+",
"line": "A journal a mom and her daughter fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "mom-and-me-son",
"t": "Mom & Me, Son Edition",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": null,
"ages": "Ages 7+",
"line": "A journal a mom and her son fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "dad-and-me-daughter",
"t": "Dad & Me, Daughter Edition",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": null,
"ages": "Ages 7+",
"line": "A journal a dad and his daughter fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "dad-and-me-son",
"t": "Dad & Me, Son Edition",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": null,
"ages": "Ages 7+",
"line": "A journal a dad and his son fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "grandma-and-me-granddaughter",
"t": "Grandma & Me, Grandmothers & Granddaughters",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": 12,
"ages": "Ages 7-12",
"line": "A journal a grandma and her granddaughter fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "grandma-and-me-grandson",
"t": "Grandma & Me, Grandmothers & Grandsons",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": 12,
"ages": "Ages 7-12",
"line": "A journal a grandma and her grandson fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "grandpa-and-me-granddaughter",
"t": "Grandpa & Me, Grandfathers & Granddaughters",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": 12,
"ages": "Ages 7-12",
"line": "A journal a grandpa and his granddaughter fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "grandpa-and-me-grandson",
"t": "Grandpa & Me, Grandfathers & Grandsons",
"who": [
"share"
],
"love": [
"together"
],
"min": 7,
"max": 12,
"ages": "Ages 7-12",
"line": "A journal a grandpa and his grandson fill in together: honest questions, fun quizzes and activities that become a keepsake of their bond.",
"by": "Sav Lucia",
"cat": "Guided Journals"
},
{
"h": "modern-calligraphy-and-hand-lettering-for-beginners",
"t": "The Complete Guide to Modern Calligraphy & Hand Lettering for Beginners",
"who": [
"grownup",
"teen"
],
"love": [
"letter"
],
"min": null,
"max": null,
"ages": null,
"line": "A complete guide and workbook to learn hand lettering from scratch: theory, 5 alphabets to practice and projects to make your own.",
"by": null,
"cat": "Hand Lettering"
},
{
"h": "letters-of-joy",
"t": "Letters of Joy",
"who": [
"grownup",
"teen"
],
"love": [
"letter"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Hand lettering and coloring with a joyful theme: learn 5 alphabet styles, letter words of gratitude and joy, then make projects of your own.",
"by": "Mariia Biriukova",
"cat": "Hand Lettering"
},
{
"h": "letters-of-love",
"t": "Letters of Love",
"who": [
"grownup",
"teen"
],
"love": [
"letter"
],
"min": null,
"max": null,
"ages": "Teens & adults",
"line": "Hand lettering and coloring to say “I love you” in your own hand: two script styles, loving quotes and creative challenges.",
"by": "Mariia Biriukova",
"cat": "Hand Lettering"
}
];
